import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=1b849724&"
import script from "./speed.vue?vue&type=script&lang=js&"
export * from "./speed.vue?vue&type=script&lang=js&"
import style0 from "./speed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports